import React, {
  PropTypes,
} from 'react';
import { Route, Switch } from 'react-router-dom';
import { Main,  } from '../components/Main';
import { About } from '../components/About';
import { Information } from '../components/Information';
import { Services } from '../components/Services';
import Message from '../components/Common/Modal/NewMessage';

function MainRouter() {
  return (
      <Switch>
        <Route exact path="/" component={ Main }/>
        <Route path="/about" component={ About }/>
        <Route path="/services" component={ Services }/>
        <Route path="/message" component={ Message }/>
        <Route path="/information" component={ Information }/>
        <Route component={ Main }/>
      </Switch>
  );
}

MainRouter.propTypes = {};
MainRouter.defaultProps = {};

export default MainRouter;



// WEBPACK FOOTER //
// ./src/Router/index.jsx